import { __decorate } from "tslib";
import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { getTaskList, deleteTask, zoneList } from '@blade-sxp/task-management/api/queue/index';
import authItem from '@blade/common/components/auth/auth-item.vue';
import tableHeader from '@blade-sxp/task-management/components/table-header.vue';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    multipleTable;
    condition;
    dateRange = ['', ''];
    startTime;
    endTime;
    keyword;
    deviceId;
    colors = colors;
    loading = false;
    taskList = [];
    taskStatus = '';
    zoneId = '';
    ellipsisName(str) {
        return str?.length > 15 ? str.slice(0, 15) + '...'
            : str;
    }
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    pageOrderList = [
        {
            orderField: 'create_time',
            orderType: 'DESC'
        }
    ];
    filterZone = [];
    filterTaskStatus = [];
    onConditionUpdate(condition) {
        this.pagination.page = 1;
        this.getTaskList();
    }
    initI18n() {
        this.filterZone = [];
        this.filterTaskStatus = [
            { text: String(this.$t('effect')), value: 'ENABLE' },
            { text: String(this.$t('noEffective')), value: 'DISABLE' },
            { text: String(this.$t('abnormal')), value: 'ERROR' },
        ];
    }
    filterZoneTag(value, row) {
        return row.zoneId === value;
    }
    filterTaskStatusTag(value, row) {
        return row.status === value;
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getTaskList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getTaskList();
    }
    getZoneList() {
        let param = {
            'externalBizFrom': '',
            'keywords': ''
        };
        zoneList(param).then((res) => {
            if (res.constructor === Array) {
                for (let i in res) {
                    if (res[i].children.length !== 0) {
                        let obj = {
                            text: '',
                            value: 0
                        };
                        obj.text = res[i].name;
                        obj.value = res[i].id;
                        this.filterZone.push(obj);
                        for (let j in res[i].children) {
                            let objChildren = {
                                text: '',
                                value: 0
                            };
                            objChildren.text = res[i].children[j].name;
                            objChildren.value = res[i].children[j].id;
                            this.filterZone.push(objChildren);
                        }
                    }
                }
            }
            else if (res.constructor === Object) {
                if (res.children.length !== 0) {
                    let obj = {
                        text: '',
                        value: 0
                    };
                    obj.text = res.name;
                    obj.value = res.id;
                    this.filterZone.push(obj);
                    for (let j in res.children) {
                        let objChildren = {
                            text: '',
                            value: 0
                        };
                        objChildren.text = res.children[j].name;
                        objChildren.value = res.children[j].id;
                        this.filterZone.push(objChildren);
                    }
                }
            }
        });
    }
    CheckedKeys(e) {
        this.zoneId = e;
        this.pagination.page = 1;
        this.getTaskList();
    }
    getTaskList() {
        this.loading = true;
        if (!this.condition.dateRange || this.condition.dateRange?.length === 0) {
            this.dateRange = ['', ''];
        }
        else {
            this.dateRange = this.condition.dateRange;
        }
        const reqParam = {
            taskTypes: ['QUEUE'],
            page: this.pagination.page,
            size: this.pagination.size,
            dateEnd: this.dateRange[1],
            dateStart: this.dateRange[0],
            pageOrderList: this.pageOrderList,
            deviceId: this.condition.device,
            keyword: this.condition.keyword,
            zoneId: this.zoneId,
            taskStatus: this.taskStatus,
        };
        getTaskList({ ...reqParam })
            .then((res) => {
            this.taskList = res.list ?? [];
            const total = res.total;
            this.pagination.total = total;
        }).finally(() => {
            this.loading = false;
            this.$refs.popover.showPopper = false;
        });
    }
    /**
     *@Description: 删除任务
     */
    handleDelete(e) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteTask(e.id)
                        .then((res) => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.getTaskList();
                    })
                        .catch((err) => {
                        this.$message({ message: err, type: 'error' });
                    });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     */
    handleEdit(id) {
        this.$router.push({ path: '/tasklist/createqueue', query: { 'id': String(id), type: 'edit' } });
    }
    sortChange(order) {
        if (order.order === 'ascending') {
            this.pageOrderList[0].orderType = 'ASC';
        }
        else {
            this.pageOrderList[0].orderType = 'DESC';
        }
        this.getTaskList();
    }
    filterChange(e) {
        if (e.taskStatus.length > 0) {
            this.taskStatus = e.taskStatus[0];
        }
        else {
            this.taskStatus = '';
        }
        this.pagination.page = 1;
        this.getTaskList();
    }
    mounted() {
        this.getTaskList();
        this.initI18n();
    }
};
__decorate([
    Ref()
], default_1.prototype, "multipleTable", void 0);
__decorate([
    Prop()
], default_1.prototype, "condition", void 0);
__decorate([
    Prop()
], default_1.prototype, "startTime", void 0);
__decorate([
    Prop()
], default_1.prototype, "endTime", void 0);
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Watch('condition', { deep: true })
], default_1.prototype, "onConditionUpdate", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'QueueTable',
        components: { authItem, tableHeader },
        i18n: {
            messages: {
                zh: {
                    taskName: '任务名称',
                    deviceName: '设备名称',
                    zoneName: '所属区域',
                    alarmType: '告警类型',
                    status: '任务状态',
                    creator: '创建人',
                    effect: '进行中',
                    noEffective: '已停用',
                    abnormal: '异常',
                    confirmDeleteAttr: '确认删除?',
                    cancel: '取消',
                    delete: '确认',
                    queueNumber: '排队人数',
                    queueTime: '排队时间',
                    deletedSuccessfully: '删除成功',
                    total: '总共 {msg} 条',
                    deleteMsg: '确定删除这个任务吗？',
                    deleteEnter: '该任务正在执行中，请暂停任务后再次尝试删除任务操作',
                    creationTime: '创建时间'
                },
                'en-us': {
                    total: 'Total {msg} Items',
                    taskName: 'Task Name',
                    deviceName: 'Device Name',
                    zoneName: 'Area Name',
                    alarmType: 'Task Type',
                    status: 'Status',
                    creator: 'Creator',
                    effect: 'Running',
                    noEffective: 'Disabled',
                    abnormal: 'Abnormal',
                    confirmDeleteAttr: 'Are you sure to delete the task？',
                    cancel: 'Cancel',
                    delete: 'Delete',
                    queueNumber: 'Queue Length',
                    queueTime: 'Waiting Time',
                    deletedSuccessfully: 'Deleted successfully',
                    deleteMsg: 'Are you sure to delete this task?',
                    deleteEnter: 'The task is in progress, please pause the task and try to delete the task again',
                    creationTime: 'Creation Time'
                },
            }
        }
    })
], default_1);
export default default_1;
